import React, { Fragment, useState } from 'react';

import { trackNavigationClicked } from '@zola/tracking-contracts/src/tracking';
import { transformNavigationLevel } from 'util/trackNavigationClickedHelpersV2';
import { getHomestoreHref } from 'util/getHomestoreHref';
import { getBabyHref } from 'util/getBabyHref';
import featureFlags from 'util/featureFlags';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import CloseIcon from '../../iconsV3/CloseIcon';
import {
  Container,
  Overlay,
  Close,
  SearchButton,
  StyledSearchIcon,
  StyledArrowIcon,
  BackToPrimaryCategoriesBtn,
  bottomBorder,
  FindCouple,
  LinkWrapper,
  BottomLinksWrapper,
} from './MobileNavMenu.styles';

import {
  getPrimaryPlan,
  primaryAdvice,
  PrimaryNavItemType,
  PrimaryNavType,
  SecondaryNavType,
} from '../../preauthNavData';
import MobileNavMenuLinkGroup from './MobileNavMenuLinkGroup';
import MobileNavMenuLinkGroupSub from './MobileNavMenuLinkGroup/MobileNavMenuLinkGroupSub';
import SignUpLogin from './SignUpLogin';

export type MobileNavMenuProps = {
  isMenuOpen?: boolean;
  toggleSearch: () => void;
  toggleMenu: () => void;
};

const MobileNavMenu = ({
  isMenuOpen,
  toggleSearch,
  toggleMenu,
}: MobileNavMenuProps): JSX.Element => {
  const [menu, setMenu] = useState<PrimaryNavType | undefined>();
  const [menuItem, setMenuItem] = useState<PrimaryNavItemType | undefined>();
  const [menuItemIndex, setMenuItemIndex] = useState(0);
  const [subMenu, setSubMenu] = useState<SecondaryNavType | undefined>();
  const findACouple = 'Find a couple';

  const handleAllBtnClick = () => {
    setSubMenu(undefined);
  };

  const handleTrackNavigationClicked = () => {
    trackNavigationClicked({
      business_category: 'UNATTRIBUTED',
      business_unit: 'UNATTRIBUTED',
      navigation_level_1: transformNavigationLevel(findACouple),
      navigation_level_1_position: 3,
      navigation_type: 'GLOBAL',
    });
  };

  return (
    <Fragment>
      <Overlay isMenuOpen={isMenuOpen} onClick={toggleMenu} />
      <Container isMenuOpen={isMenuOpen}>
        <Close aria-label="Close" type="button" onClick={toggleMenu}>
          <CloseIcon width={24} height={24} showTitle={false} />
        </Close>
        {menu && menuItem && subMenu ? (
          <Fragment>
            <BackToPrimaryCategoriesBtn onClick={handleAllBtnClick}>
              <StyledArrowIcon direction="left" />
              Main menu
            </BackToPrimaryCategoriesBtn>
            <MobileNavMenuLinkGroupSub
              menu={menu}
              menuItem={menuItem}
              menuItemIndex={menuItemIndex}
              subMenu={subMenu}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div css={bottomBorder}>
              <SearchButton onClick={toggleSearch}>
                <StyledSearchIcon height={20} width={20} />
                Search gifts, vendors, couples...
              </SearchButton>
            </div>
            <div css={bottomBorder}>
              <SignUpLogin />
            </div>
            {[getPrimaryPlan(), primaryAdvice].map((linkGroups, index) => (
              <MobileNavMenuLinkGroup
                key={index}
                css={bottomBorder}
                linkGroups={linkGroups}
                setMenu={setMenu}
                setMenuItem={setMenuItem}
                setMenuItemIndex={setMenuItemIndex}
                setSubMenu={setSubMenu}
              />
            ))}
            <FindCouple href="/search/wedding-registry" onClick={handleTrackNavigationClicked}>
              {findACouple}
            </FindCouple>
          </Fragment>
        )}
        <BottomLinksWrapper>
          <LinkWrapper>
            Become a Zola{' '}
            <LinkV2 subtle inline href="https://welcome.zola.com/for-vendors/">
              vendor
            </LinkV2>
          </LinkWrapper>
          <LinkWrapper>
            Just here to shop? Explore{' '}
            <LinkV2 subtle inline href={getHomestoreHref(featureFlags.getEnvironment())}>
              Zola Home
            </LinkV2>
          </LinkWrapper>
          <LinkWrapper>
            Start a baby registry with{' '}
            <LinkV2 subtle inline href={getBabyHref(featureFlags.getEnvironment())}>
              Zola Baby
            </LinkV2>
          </LinkWrapper>
        </BottomLinksWrapper>
      </Container>
    </Fragment>
  );
};

export default MobileNavMenu;
